module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-UltraLightIt.1bf93e13.woff2";